

import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Calendar } from 'primereact/calendar';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import { LuChevronDown, LuChevronRight } from 'react-icons/lu';
import { useData } from '../data/general/DataContext';
import NotificationIcons from '../components/NotificationIcon';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { useDispatch } from 'react-redux';
import { exportPdfDownload, exportPdfPrint } from '../storage/slices/DownloadSlice';
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import QuickAssignModal from "../modals/service/QuickAssignModal"; // 🔹 Modal import edildi




export default function TablePage({
  title = "",
  subTitle = "",
  columns = [],
  data = [],
  rowsPerPageOptions = [10, 15, 25, 50,100],
  defaultRows = 10,
  showSearch = true,
  onAdd = null,
  showDateFilter = false,
  columnFilterOptions = {},
  rounded = 8,
  scrollableControls = false,
  hideHeaderRight = false,
  modalFilterStyle = false,
  showHeader = true,
  showPrint = true,
  showDownload = true,
  calendarStyle,
  searchStyle,
  cashPageStyle,
  extraHeaderContent,
  extraFormHeader,
  rowClassName
}) {
  const [first, setFirst] = useState(0);
  const dispatch = useDispatch();

  const [rows, setRows] = useState(defaultRows);
  const [globalFilter, setGlobalFilter] = useState('');
  const [dateRange, setDateRange] = useState(null);
  const [columnFilters, setColumnFilters] = useState({});
  const [columnsOpen, setColumnsOpen] = useState({});
  const { windowMode, setWindowMode } = useData();
  const [showMobileActions, setShowMobileActions] = useState(false);

  const op = useRef(null);
  const filterButtonRef = useRef(null);
  const [filterButtonTop, setFilterButtonTop] = useState(0);
  const [filterButtonLeft, setFilterButtonLeft] = useState(0);
  const [expandedRows, setExpandedRows] = useState(null);


  const [domReady, setDomReady] = useState(false);

  const [showQuickAssignModal, setShowQuickAssignModal] = useState(false);

  useEffect(() => {
    setDomReady(true);
  }, []);

  const toggleColumn = (field) => setColumnsOpen(prev => ({ ...prev, [field]: !prev[field] }));
  const onPage = (event) => { setFirst(event.first); setRows(event.rows); };

  const filteredData = data.filter(item => {
    const matchesSearch = columns.some(col =>
      col.field && String(item[col.field] ?? '').toLowerCase().includes(globalFilter.toLowerCase())
    );
    const matchesDate = showDateFilter && dateRange && dateRange[0] && dateRange[1]
      ? item.date && new Date(item.date) >= dateRange[0] && new Date(item.date) <= dateRange[1]
      : true;

    const matchesColumns = Object.entries(columnFilters).every(([field, value]) => {
      if (!value || (Array.isArray(value) && value.length === 0)) return true;
      if (Array.isArray(value)) return value.includes(item[field]);
      return String(item[field] ?? '').toLowerCase().includes(value.toLowerCase());
    });
    return matchesSearch && matchesDate && matchesColumns;
  });

  useEffect(() => {
    const updateFilterPosition = () => {
      if (filterButtonRef.current) {
        const rect = filterButtonRef.current.getBoundingClientRect();
        setFilterButtonTop(rect.bottom + 8);
        setFilterButtonLeft(rect.left);
      }
    };
    updateFilterPosition();
    window.addEventListener('resize', updateFilterPosition);
    window.addEventListener('scroll', updateFilterPosition);
    return () => {
      window.removeEventListener('resize', updateFilterPosition);
      window.removeEventListener('scroll', updateFilterPosition);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => setWindowMode(window.innerWidth <= 767 ? 'mobile' : 'web');
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [setWindowMode]);

  const showFilterPanel = (e) => { if (op.current) op.current.toggle(e); };

  return (
    <div className="outletpage-container">
      <div className="p-0 w-full ">
        {showHeader && (
          <div className="flex justify-between items-start mb-3">
            <div>
              <h1 className={windowMode === 'mobile' ? "tablepage-title-mobile" : "tablepage-title"}>
                {title}
              </h1>
              {subTitle && (
                <p className={windowMode === 'mobile' ? "tablepage-subtitle-mobile" : "tablepage-subtitle"}>
                  {subTitle}
                </p>
              )}
            </div>
            {!hideHeaderRight && <NotificationIcons notificationCount={3} />}
          </div>
        )}


        {/* Arama ve Tarih Aralığı */}
        <div className={`flex ${windowMode === 'mobile' ? 'flex-col gap-2 px-3' : scrollableControls ? 'flex-row gap-3 mx-0' : 'flex-row justify-between items-center'} mb-4`}>
          {showSearch && (
            <div className="relative flex flex-col w-[204px]" style={searchStyle}>
              <div className="flex items-center h-[36px]">
                <i className="pi pi-search absolute left-2 top-1/2 -translate-y-1/2 text-black text-[20px]"></i>
                <input
                  type="text"
                  placeholder="İşlem Ara"
                  className="custom-input pl-9"
                  value={globalFilter}
                  onChange={(e) => setGlobalFilter(e.target.value)}
                />
              </div>
            </div>
          )}

          {showDateFilter && (
            <div className={`${windowMode === 'mobile' ? 'w-full ' : 'ml-2'}`} style={calendarStyle}>
              <Calendar
                value={dateRange}
                onChange={(e) => setDateRange(e.value || null)}
                selectionMode="range"
                readOnlyInput
                placeholder="Tarih Aralığı Seç"
                showIcon
                className="custom-calendar"
              />
            </div>
          )}




          {/* Sağ Butonlar */}

          <div className="flex items-end ml-auto space-x-3" style={cashPageStyle}>
            {windowMode === 'web' ? (
              <>
                {/* Yazdır */}
                {showPrint && (
                  <Button
                    icon="pi pi-print"
                    className="custom-gray-button p-button-md"
                    tooltip="Yazdır"
                    onClick={() => {
                      exportPdfPrint({
                        rowsPerPage: rows,
                        data: filteredData,
                        cols: columns.map(c => ({ name: c.header, value: c.field })),
                        pdftitle: title,
                        filtervalue: globalFilter,
                        filterpageindex: Math.floor(first / rows)
                      });
                    }}
                  />
                )}

                {showDownload && ( // İndir
                  <Button
                    icon="pi pi-download"
                    className="p-button-md custom-gray-button"
                    tooltip="İndir"
                    onClick={() => {
                      exportPdfDownload({
                        rowsPerPage: rows,
                        data: filteredData,
                        cols: columns.map(c => ({ name: c.header, value: c.field })),
                        pdftitle: title,
                        filtervalue: globalFilter,
                        filterpageindex: Math.floor(first / rows)
                      });
                    }}
                  />
                )}

                {/* Filtrele Butonu */}

                <div
                  ref={filterButtonRef}
                  className="filter-button"
                  onClick={showFilterPanel}
                >
                  <span className="text-gray-700">Filtrele</span>
                  <FilterListOutlinedIcon className="filter-icon" />
                </div>
                {/* Yeni prop */}
                {extraHeaderContent}
                {/* 🔹 Yalnızca Servis sayfasında görünen Hızlı Servis Ata */}
                {title === "Servis" && (
                  <Button
                    label="Hızlı Servis Ata"
                    className="button-primary"
                    onClick={() => setShowQuickAssignModal(true)}
                  />
                )}
                {/* İşlem Ekle */}
                {onAdd && title !== "Servis Aksiyonları" && (
                  <Button
                    label="İşlem Ekle"
                    className="button-primary"
                    onClick={onAdd}
                  />
                )}


              </>
            ) : (

              <div className="flex gap-2 items-center mt-4">
                {/* Mobil için filtre */}
                <div ref={filterButtonRef}
                  className="flex items-center justify-center cursor-pointer px-2 py-1 rounded bg-white text-gray-700"
                  onClick={showFilterPanel}
                  style={{ fontWeight: 400, fontSize: '12px', lineHeight: '16px' }}>
                  <span>Filtrele</span>
                  <FilterListOutlinedIcon className="filter-icon" />
                </div>

                {!extraHeaderContent && (
                  <div className="relative w-36">
                    <Button
                      label="İşlem Seç"
                      className="p-button-sm w-full"
                      style={{ height: '36px', borderRadius: '8px', fontSize: '13px', backgroundColor: '#0d6efd', color: 'white' }}
                      onClick={() => setShowMobileActions(!showMobileActions)}
                    />
                    {showMobileActions && (
                      <div className="absolute right-0 mt-1 w-40 bg-white border border-gray-200 rounded-lg shadow-md z-50 flex flex-col overflow-hidden">
                        {showPrint && (
                          <Button
                            icon="pi pi-print"
                            label="Yazdır"
                            className="p-button-sm p-button-text flex items-center gap-2 px-3 py-2 text-gray-700 hover:bg-gray-100"
                            style={{ justifyContent: "flex-start", textAlign: "left" }}
                            onClick={() => {
                              exportPdfPrint({
                                rowsPerPage: rows,
                                data: filteredData,
                                cols: columns.map(c => ({ name: c.header, value: c.field })),
                                pdftitle: title,
                                filtervalue: globalFilter,
                                filterpageindex: Math.floor(first / rows)
                              });
                            }}
                          />
                        )}

                        {showDownload && (
                          <Button
                            icon="pi pi-download"
                            label="İndir"
                            className="p-button-sm p-button-text flex items-center gap-2 px-3 py-2 text-gray-700 hover:bg-gray-100"
                            style={{ justifyContent: "flex-start", textAlign: "left" }}
                             onClick={() => {
                              exportPdfDownload({
                                rowsPerPage: rows,
                                data: filteredData,
                                cols: columns.map(c => ({ name: c.header, value: c.field })),
                                pdftitle: title,
                                filtervalue: globalFilter,
                                filterpageindex: Math.floor(first / rows)
                              });
                            }}
                          />
                        )}

                        {onAdd && (
                          <Button
                            icon="pi pi-plus"
                            label="İşlem Ekle"
                            className="p-button-sm p-button-text flex items-center gap-2 px-3 py-2 text-gray-700 hover:bg-gray-100"
                            style={{ justifyContent: "flex-start", textAlign: "left" }}
                            onClick={onAdd}
                          />
                        )}
                        {/* 🔹 Mobilde Hızlı Servis Ata butonu */}
                        {title === "Servis" && (
                          <Button
                            icon="pi pi-bolt"
                            label="Hızlı Servis Ata"
                            className="p-button-sm p-button-text flex items-center gap-2 px-3 py-2 text-blue-600 hover:bg-gray-100"
                            style={{ justifyContent: "flex-start", textAlign: "left" }}
                            onClick={() => setShowQuickAssignModal(true)}
                          />
                        )}
                      </div>
                    )}
                  </div>
                )}

                {extraHeaderContent && <div className="ml-0  flex-1">{extraHeaderContent}</div>}
              </div>
            )}
          </div>




          {/* Filtre Paneli */}
          {domReady && (
            <OverlayPanel
              ref={op}
              appendTo={document.body}
              dismissable={windowMode !== "mobile"}
              style={modalFilterStyle ? {
                width: windowMode === 'mobile' ? '100%' : '320px',
                position: windowMode === 'mobile' ? 'absolute' : 'fixed',
                top: windowMode === 'mobile' ? '0' : `${filterButtonTop}px`,
                left: windowMode === 'mobile' ? '0' : `${filterButtonLeft}px`,
                padding: '1rem',
                overflowY: 'auto',
                backgroundColor: "rgba(255,255,255,0.95)",
                maxHeight: windowMode === 'mobile' ? '100vh' : `calc(100vh - ${filterButtonTop}px)`,
                zIndex: 1000,
              } : {
                width: windowMode === 'mobile' ? '100%' : `calc(100vw - ${filterButtonLeft}px)`,
                position: "absolute",
                top: windowMode === 'mobile' ? '0' : `${filterButtonTop}px`,
                left: windowMode === 'mobile' ? '0' : `${filterButtonLeft}px`,
                height: windowMode === 'mobile' ? '100vh' : `calc(100vh - ${filterButtonTop}px)`,
                padding: '1rem',
                overflowY: 'auto',
                backgroundColor: "rgba(255,255,255,0.95)",
                zIndex: 1000,
              }} onShow={() => document.body.style.overflow = 'hidden'}
              onHide={() => document.body.style.overflow = 'auto'}
            >



              {columns
                .filter(col => !col.hideInFilter)
                .map((col) => {
                  const options = columnFilterOptions[col.field]?.options || [];
                  const value = columnFilterOptions[col.field]?.value ?? columnFilters[col.field] ?? '';
                  const onChange = columnFilterOptions[col.field]?.onChange ?? ((val) => setColumnFilters({ ...columnFilters, [col.field]: val }));
                  const open = columnsOpen[col.field] || false;

                  return (
                    <div key={col.field} className="border-b border-gray-200 py-2">
                      <button
                        className="flex justify-between items-center w-full text-left px-2 py-2 hover:bg-gray-50"
                        onClick={() => toggleColumn(col.field)}
                      >
                        {col.header}
                        <span>{open ? <LuChevronDown /> : <LuChevronRight />}</span>
                      </button>
                      {open && (
                        <div className="flex flex-col mt-2 gap-2">
                          {columnFilterOptions[col.field]?.type === 'custom' ? (
                            columnFilterOptions[col.field].body()
                          ) : columnFilterOptions[col.field]?.type === 'autocomplete' ? (
                            <Autocomplete
                              options={options}
                              value={value || null}
                              onChange={(e, newValue) => onChange(newValue)}
                              disabled={columnFilterOptions[col.field]?.disabled}
                              renderInput={(params) => <TextField {...params} label={col.header} size="small" />}
                              style={{ width: '100%' }}
                            />
                          ) : columnFilterOptions[col.field]?.type === 'checkbox' ? (
                            options.map((opt) => (
                              <label key={opt} className="flex items-center gap-2 cursor-pointer text-sm">
                                <input
                                  type="checkbox"
                                  checked={Array.isArray(columnFilters[col.field]) ? columnFilters[col.field].includes(opt) : false}
                                  onChange={(e) => {
                                    let newValues = Array.isArray(columnFilters[col.field]) ? [...columnFilters[col.field]] : [];
                                    if (e.target.checked) newValues.push(opt);
                                    else newValues = newValues.filter((v) => v !== opt);
                                    setColumnFilters({ ...columnFilters, [col.field]: newValues });
                                    onChange(newValues);
                                  }}
                                />
                                {opt}
                              </label>
                            ))
                          ) : (
                            <input
                              type="text"
                              placeholder={`${col.header} ara...`}
                              value={columnFilters[col.field] || ''}
                              onChange={(e) => {
                                setColumnFilters({ ...columnFilters, [col.field]: e.target.value });
                                onChange(e.target.value);
                              }}
                              className="border border-gray-300 rounded px-2 py-1"
                            />
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}



              <div className="flex gap-2 mt-4">
                <Button label="Temizle" className="button-secondary flex-1" onClick={() => { setColumnFilters({}); setDateRange([null, null]); }} />
                <Button label="Uygula" className="button-primary flex-1" onClick={() => op.current.hide()} />
              </div>

              {/* Mobilde Kapat Butonu */}
              {windowMode === 'mobile' && (
                <button
                  onClick={() => op.current.hide()}
                  className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 text-3xl font-bold"
                >
                  &times;
                </button>
              )}
            </OverlayPanel>
          )}

          {/* QuickAssign Modal */}
          <QuickAssignModal
            show={showQuickAssignModal}
            handleClose={() => setShowQuickAssignModal(false)}
          />

        </div>
        {/* 🔹 extraFormHeader  */}
        {extraFormHeader && (
          <div className="mb-4 px-0">
            {extraFormHeader}
          </div>
        )}
        {/* Masaüstü Tablo */}
        <div className={`${windowMode === 'web' ? 'block' : 'hidden'} px-0`}>
          <div className="overflow-hidden shadow-sm border border-gray-200" style={{ borderRadius: rounded === false ? "0 0 8px 8px" : typeof rounded === "number" ? `${rounded}px` : rounded === true ? "8px" : rounded }}>
            <DataTable
              value={filteredData}
              paginator
              rows={rows}
              paginatorPosition="bottom"
              first={first}
              onPage={onPage}

              totalRecords={filteredData.length}
              paginatorClassName="custom-paginator  justify-between items-center px-4"
              paginatorTemplate={{
                layout: 'PageLinks',
                PageLinks: (opt) => {
                  if (opt.page !== 0) return null;

                  const totalPages = Math.ceil(filteredData.length / rows);
                  const currentPage = Math.floor(first / rows);

                  const toPage = (p) => onPage({ first: p * rows, rows });
                  const goPrev = () => { if (currentPage > 0) toPage(currentPage - 1); };
                  const goNext = () => { if (currentPage < totalPages - 1) toPage(currentPage + 1); };

                  return (
                    <div className="flex items-center gap-2 justify-center">
                      <button
                        onClick={goPrev}
                        className={`px-3 py-1 rounded ${currentPage === 0 ? 'opacity-50 cursor-not-allowed' : ''}`}
                      >
                        &lt;
                      </button>

                      <div className="flex gap-2">
                        {Array.from({ length: totalPages }, (_, i) => (
                          <button
                            key={i}
                            onClick={() => toPage(i)}
                            className="px-2 py-1 rounded"
                          >
                            {i + 1}
                          </button>
                        ))}
                      </div>

                      <button
                        onClick={goNext}
                        className={`px-3 py-1 rounded ${currentPage === totalPages - 1 ? 'opacity-50 cursor-not-allowed' : ''}`}
                      >
                        &gt;
                      </button>
                    </div>
                  );
                },
              }}
              paginatorLeft={<div>{`${Math.min(first + 1, filteredData.length)} - ${Math.min(first + rows, filteredData.length)} / ${filteredData.length} gösteriliyor`}</div>}
              paginatorRight={
                <div>
                  <select className="border rounded px-2 py-1" value={rows} onChange={(e) => setRows(parseInt(e.target.value, 10))}>
                    {rowsPerPageOptions.map((opt) => (<option key={opt} value={opt}>{opt}</option>))}
                  </select>
                </div>
              }
              tableStyle={{ width: '100%', borderSpacing: '0', borderCollapse: 'separate', tableLayout: 'fixed' }}
              responsiveLayout="scroll"
              rowClassName={(rowData) => {
                if (typeof rowClassName === "function") {
                  return rowClassName(rowData) + " custom-row-border";
                }
                return "custom-row-border";
              }}

            >
              {columns
                .filter(col => !col.hideInTable)
                .map((col, idx) => (
                  <Column
                    key={idx}
                    field={col.field}
                    header={col.header}
                    body={col.body ? (rowData) => col.body(rowData) : undefined}
                    style={{
                      width: col.field === 'id' ? '6%' : `${(100 - 6) / (columns.length - 1)}%`,
                      padding: '8px',
                      textAlign: 'left',
                      verticalAlign: 'middle',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }}
                    headerClassName="custom-header px-3"
                    sortable
                  />
                ))
              }

            </DataTable>
          </div>
        </div>


        {/* 📱 Mobile Table */}
        <div className={`${windowMode === 'mobile' ? 'block' : 'hidden'} px-0`}>
          <div className="overflow-hidden rounded-xl shadow-md border border-gray-200">
            <DataTable
              value={filteredData}
              paginator
              first={first}
              rows={rows}
              rowsPerPageOptions={rowsPerPageOptions}
              onPage={onPage}
              paginatorTemplate="PrevPageLink PageLinks NextPageLink"
              currentPageReportTemplate="{first} / {totalRecords}"
              paginatorClassName="custom-paginat"
              tableStyle={{ width: '100%', borderCollapse: 'collapse' }}
              rowClassName={(rowData) => {
                if (typeof rowClassName === "function") {
                  return rowClassName(rowData) + " custom-row-border";
                }
                return "custom-row-border";
              }}
              expandedRows={expandedRows}
              onRowToggle={(e) => setExpandedRows(e.data)}
              rowExpansionTemplate={(rowData) => (
                <div className="p-3 border-t border-gray-200 flex flex-col gap-2">
                  {columns.filter(col => !col.hideInTable).map((col, idx) => (
                    <div key={idx} className="flex justify-between text-sm">
                      <span className="text-sm text-black">{col.header}</span>
                      <span className="text-gray-600">{col.body ? col.body(rowData) : rowData[col.field]}</span>
                    </div>
                  ))}
                </div>
              )}

            >
              <Column expander style={{ width: '3em',height:35, }}  />
              <Column field="id" header="ID" style={{ width: '30%' }} headerStyle={{ fontSize: '1rem', paddingRight: '20px', paddingLeft: '0px', backgroundColor: 'rgba(243, 243, 243, 1)' }} sortable filterPlaceholder="Ara ID..." />
              <Column
                field="name"
                header="İsim"
                body={(rowData) => (
                  <div className="flex flex-col gap-1">
                    <div className="flex gap-5 items-center">
                      <span>{rowData.fullName || rowData.name || rowData.customerIdName || rowData.deviceModel || rowData.plate || rowData.model || rowData.supplierName || rowData.description || rowData.offerDate}</span>
                    </div>
                  </div>
                )}
                style={{ width: '70%', fontSize: '1rem' }}
                headerStyle={{ paddingLeft: '20px', backgroundColor: 'rgba(243, 243, 243, 1)' }}

                sortable

                filterPlaceholder="Ara İsim..."
              />
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  );
}

